import { useEffect } from 'react';
import type { ReactNode } from 'react';
import { useTenantConfig } from '../hooks/useTenantConfig';
import { setFormatLocale } from '../services/formatting.service';

/**
 * Syncs the tenant's format_locale setting into the formatting service's
 * module-level locale. Renders nothing — just keeps the global in sync.
 */
export function FormatLocaleProvider({ children }: { children: ReactNode }) {
  const { data: config } = useTenantConfig();

  useEffect(() => {
    if (config?.format_locale) {
      setFormatLocale(config.format_locale);
    }
  }, [config?.format_locale]);

  return <>{children}</>;
}
